/**
 * @generated SignedSource<<d9d56030c61740df16c044ba60e49087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type PageTreeInitialDataNode_ptpage$data = {
  readonly blank: boolean | null;
  readonly createdDate: {
    readonly value: string;
  } | null;
  readonly hasChildren: boolean;
  readonly id: string;
  readonly links: {
    readonly webui: string | null;
  } | null;
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly status: PTGraphQLPageStatus | null;
  readonly subType: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "PageTreeInitialDataNode_ptpage";
};
export type PageTreeInitialDataNode_ptpage$key = {
  readonly " $data"?: PageTreeInitialDataNode_ptpage$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageTreeInitialDataNode_ptpage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "value"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PageTreeInitialDataNode_ptpage",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "MILLIS"
        }
      ],
      "concreteType": "ConfluenceDate",
      "kind": "LinkedField",
      "name": "createdDate",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": "createdDate(format:\"MILLIS\")"
    },
    {
      "kind": "ScalarField",
      "name": "hasChildren"
    },
    {
      "kind": "ScalarField",
      "name": "blank"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "Map_LinkType_String",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "emoji-title-published",
            "emoji-title-draft",
            "editor",
            "jira-planner-connection"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "key"
            },
            (v1/*: any*/),
            {
              "concreteType": "Version",
              "kind": "LinkedField",
              "name": "version",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "number"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }
  ],
  "type": "PTPage"
};
})();

(node as any).hash = "4869d2ac61ff6e6c98b36fb6170cd011";

export default node;
